import { type SVGProps } from "react";
import { cn } from "@/lib/utils";

interface ColorSwatchProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const ColorSwatch = ({
  color = "#e5e7eb",
  className,
  ...props
}: ColorSwatchProps) => {
  return (
    <svg
      data-testid="color-swatch"
      viewBox="0 0 12 12"
      aria-hidden="true"
      className={cn("h-3 w-3 shrink-0 text-border", className)}
      {...props}
    >
      <circle cx="6" cy="6" r="5" fill={color} stroke="currentColor" />
    </svg>
  );
};
